export { default as ListarEmpleados} from './Listar';
export { default as NuevoEmpleado} from './Nuevo';
export { default as DetalleEmpleado} from './Detalle';
